//resources action names
export type SET_RESOURCES = "SET_RESOURCES"
export const SET_RESOURCES = "SET_RESOURCES"

//filter action names
export type UPDATE_FILTER_STATE = "UPDATE_FILTER_STATE"
export const UPDATE_FILTER_STATE = "UPDATE_FILTER_STATE"

export type RESET_FILTER_STATE = "RESET_FILTER_STATE"
export const RESET_FILTER_STATE = "RESET_FILTER_STATE"

export type SET_PARAMS = "SET_PARAMS"
export const SET_PARAMS = "SET_PARAMS"

export type UPDATE_FILTER_STATE_W_PARAMS = "UPDATE_FILTER_STATE_W_PARAMS"
export const UPDATE_FILTER_STATE_W_PARAMS = "UPDATE_FILTER_STATE_W_PARAMS"

//filtered action names

export type SET_PRODCUTS = "SET_PRODCUTS"
export const SET_PRODCUTS = "SET_PRODCUTS"

export type FILTER = "FILTER"
export const FILTER = "FILTER"

//cart action names
export type ADD_TO_CART = "ADD_TO_CART"
export const ADD_TO_CART = "ADD_TO_CART"

export type INCREMENT_CART = "INCREMENT_CART"
export const INCREMENT_CART = "INCREMENT_CART"

export type DECREMENT_CART = "DECREMENT_CART"
export const DECREMENT_CART = "DECREMENT_CART"

export type REMOVE_ITEM_CART = "REMOVE_ITEM_CART"
export const REMOVE_ITEM_CART = "REMOVE_ITEM_CART"

export type SET_CART_DATA = "SET_CART_DATA"
export const SET_CART_DATA = "SET_CART_DATA"

export type SET_CART_LOADING = "SET_CART_LOADING"
export const SET_CART_LOADING = "SET_CART_LOADING"

export type SET_CART_ERROR = "SET_CART_ERROR"
export const SET_CART_ERROR = "SET_CART_ERROR"

export type SET_CART_SUCCESS = "SET_CART_SUCCESS"
export const SET_CART_SUCCESS = "SET_CART_SUCCESS"

export type RESET_CART_LOADING_STATE = "RESET_CART_LOADING_STATE"
export const RESET_CART_LOADING_STATE = "RESET_CART_LOADING_STATE"